import { alertConstants } from "../../constants";

const error = (message) => {
  return { type: alertConstants.ALERT_ERROR, payload: { message } };
}

const info = (message) => {
  return { type: alertConstants.ALERT_INFO, payload: { message } };
}

const success = (message) => {
  return { type: alertConstants.ALERT_SUCCESS, payload: { message }};
}

const warning = (message) => {
  return { type: alertConstants.ALERT_WARNING, payload: { message }};
}

const reset = () => {
  return { type: alertConstants.ALERT_RESET, payload: null };
}

export const alertActions = {
  error,
  info,
  success,
  warning,
  reset,
};